import { useState, useEffect, useRef } from 'react'

const useDeferredRender = (frames = 1) => {
  const [shouldRender, setShouldRender] = useState(false)
  const frameCountRef = useRef(0)
  const rafRef = useRef(null)

  useEffect(() => {
    frameCountRef.current = 0 // Reset count when frames changes - which shouldn't happen
    let isMounted = true

    const renderAfterFrames = () => {
      if (!isMounted) return

      frameCountRef.current += 1
      if (frameCountRef.current >= frames) {
        setShouldRender(true)
      } else {
        rafRef.current = requestAnimationFrame(renderAfterFrames)
      }
    }

    rafRef.current = requestAnimationFrame(renderAfterFrames)

    return () => {
      isMounted = false
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current) // Clean up pending animation frames
      }
    }
  }, [frames])

  return shouldRender
}

export default useDeferredRender
